import * as React from 'react';
import { PLANS } from '../../../lib/Plans';
import Chip from '../Chip/Chip';
import cn from '~modules/cn';

import './plan-card.scss';

type Props = {
    tierId: string;
    amount?: number;
    themeName?: string;
    isCurrent?: boolean;
    className?: string;
    children?: React.ReactNode;
};

const PlanCard = (props: Props) => {
    const plan = PLANS[props.tierId];
    if (!plan) {
        return null;
    }
    const amount = typeof props.amount === 'number' ? props.amount : plan.defaultPrice;
    return (
        <div className={cn('plan-card', props.className)}>
            <div className="plan-card__title-container">
                <div className="plan-card__title">{plan.title}</div>
                <div className="plan-card__price">{typeof amount === 'number' ? `$${(amount / 100).toFixed(2).replace(/\.00$/, '')}/mo` : ''}</div>
                {props.isCurrent && <Chip text="Current plan" type="primary" />}
            </div>
            <div className="plan-card__items">
                {plan.benefits.map((benefit, index) => {
                    if (index === 0 && props.themeName) {
                        benefit = `${benefit} - ${props.themeName}`;
                    }
                    return <div key={index}>{benefit}</div>;
                })}
            </div>
            {props.children && <div className="plan-card__children">{props.children}</div>}
        </div>
    );
};

export default PlanCard;
